module.exports = __webpack_public_path__ + "img/chr_ts_16.8550fdea.png";